(function () {
  angular
    .module("akitabox.serviceRequest.detail")
    .controller(
      "DetailServiceRequestController",
      DetailServiceRequestController
    );

  /* @ngInject */
  function DetailServiceRequestController(
    // Angular
    $scope,
    // Third Party
    $state,
    // Akitabox
    models,
    // Resolve
    building,
    serviceRequest,
    // Services
    NoteService,
    ToastService,
    ShadowService,
    DenyRequestDialog,
    DeleteRequestDialog,
    ReopenRequestDialog,
    DisplayTextDialog,
    UserService,
    // Utilities
    Utils
  ) {
    var self = this;

    var currentUser = UserService.getCurrent();
    var permissions = UserService.getPermissions();

    // Attributes
    self.activeTab = 0;
    self.building = building;
    self.request = serviceRequest;
    self.headerActions = getHeaderActions();
    self.canViewTask = false;
    self.actionMenuOpen = false;
    self.isOpened = true;

    // Activity
    self.lastActivityItem = {
      activityType: "created-entity",
      entity: "Service Request",
      time: self.request.created_date,
      created_by: { display_name: self.request.requester_email },
    };
    self.activityParams = {
      request: self.request._id,
    };

    // Controller states
    self.editState = false;

    // Functions
    self.addWorkOrder = addWorkOrder;
    self.denyRequest = denyRequest;
    self.deleteRequest = deleteRequest;
    self.reopenRequest = reopenRequest;
    self.getStatusClass = getStatusClass;
    self.goToBuilding = goToBuilding;
    self.goToWorkOrder = goToWorkOrder;
    self.showActivityTab = showActivityTab;
    self.showDetailsTab = showDetailsTab;
    self.formatPhoneNumber = Utils.formatPhoneNumber;
    self.createNote = createNote;
    self.createNewRequest = createNewRequest;
    self.createNewWorkOrder = createNewWorkOrder;
    self.toggleActionMenu = toggleActionMenu;
    self.showDescription = showDescription;
    self.showSubject = showSubject;

    init();

    function init() {
      if (permissions.task.read_all) {
        self.canViewTask = true;
      } else {
        self.canViewTask =
          self.request.task &&
          self.request.task.assignee_users.includes(currentUser._id);
      }
    }

    /**
     * Retrieve class for service request status (open, new, etc.)
     *
     * @param  {Object} serviceRequest   Service Request
     * @return {String}                  Class name
     */
    function getStatusClass() {
      switch (self.request.status) {
        case "new":
          return "fg-success";
        case "denied":
          return "fg-warn";
        case "deleted":
          return "fg-warn";
        case "completed":
          return "fg-success";
        default:
          return "fg-white";
      }
    }

    function showDescription() {
      DisplayTextDialog.show({
        locals: {
          title: "Description",
          displayText: self.request.description,
        },
      });
    }

    function showSubject() {
      DisplayTextDialog.show({
        locals: {
          title: "Subject",
          displayText: self.request.subject,
        },
      });
    }

    function goToBuilding() {
      $state.go("app.building.detail", {
        accountId: self.building.cre_account,
        buildingId: self.building._id,
      });
    }

    function goToWorkOrder() {
      $state.go("app.building.workOrder.detail", {
        accountId: self.building.cre_account,
        buildingId: self.building._id,
        workOrderId: self.request.task._id,
      });
    }

    function toggleActionMenu() {
      self.actionMenuOpen = !self.actionMenuOpen;
    }

    function addWorkOrder() {
      // Send a create-workorder GA event.
      ShadowService.sendEvent("workorder", "create-workorder");

      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;
      params[models.SERVICE_REQUEST.ROUTE_SINGULAR] = self.request._id;

      $state.go("app.workOrders.create", params);
    }

    function createNewRequest() {
      $state.go("app.serviceRequests.create", {
        building: self.building._id,
      });
    }

    function createNewWorkOrder() {
      $state.go("app.workOrders.create", {
        building: self.building._id,
      });
    }

    function denyRequest() {
      DenyRequestDialog.show({
        locals: {
          requests: [self.request],
        },
      }).then(function () {
        $state.go(
          "app.building.serviceRequest.detail",
          {
            buildingId: self.building._id,
            requestId: self.request._id,
          },
          {
            reload: true,
          }
        );
      });
    }

    function deleteRequest() {
      DeleteRequestDialog.show({
        locals: {
          requests: [self.request],
        },
      }).then(function () {
        $state.go(
          "app.building.serviceRequests",
          {
            buildingId: self.building._id,
          },
          {
            reload: true,
          }
        );
      });
    }

    function reopenRequest() {
      ReopenRequestDialog.show({
        locals: {
          requests: [self.request],
        },
      }).then(function () {
        $state.go(
          "app.building.serviceRequest.detail",
          {
            buildingId: self.building._id,
            requestId: self.request._id,
          },
          {
            reload: true,
          }
        );
      });
    }

    function showActivityTab() {
      self.activeTab = 1;
      self.isOpened = true;
      self.needWorkOrderActivity = true;
    }

    function showDetailsTab() {
      self.activeTab = 0;
      self.isOpened = true;
    }

    // TODO refactor when `flexible_client_permissions` flag is removed
    function getHeaderActions() {
      var actions = [];

      var createWOAction = {
        label: "Create WO",
        class: "createwo",
        icon: "assignment",
        action: addWorkOrder,
      };
      var denySRAction = {
        label: "Deny",
        class: "deny",
        icon: "close",
        action: denyRequest,
      };
      var deleteSRAction = {
        label: "Delete",
        class: "delete",
        icon: "delete",
        action: deleteRequest,
      };
      var reopenSRAction = {
        label: "Reopen",
        class: "reopen",
        icon: "restore",
        action: reopenRequest,
      };
      var addMsgAction = {
        label: "Add Msg",
        class: "msg",
        icon: "message",
        action: () => {
          self.actionMenuOpen = false;
          showActivityTab();
        },
      };

      var canCreateWO = false;
      var canDeny = false;
      var canDelete = false;
      var canReopen = false;

      canCreateWO = permissions.task.create;
      canDeny = permissions.request.deny;
      canDelete = permissions.request.remove;
      canReopen = permissions.request.reopen;

      if (self.request.is_new && canCreateWO) {
        actions.push(createWOAction);
      }

      if (self.request.is_new && canDeny) {
        actions.push(denySRAction);
      }

      if (self.request.is_denied && canReopen) {
        actions.push(reopenSRAction);
      }

      if (self.request.is_denied && canDelete) {
        actions.push(deleteSRAction);
      }

      actions.push(addMsgAction);

      return actions;
    }

    function createNote(noteText, sendToRequester) {
      if (!noteText || !noteText.length) return;
      var data = {
        request: self.request._id,
        building: self.building._id,
        text: noteText,
        is_public: sendToRequester,
      };

      if (sendToRequester) {
        data.emailRequester = true;
      }
      if (self.request.task) {
        data.task = self.request.task._id || self.request.task;
      }

      NoteService.create(self.building._id, data)
        .then(function (note) {
          refreshActivity();
        })
        .catch(ToastService.showError);
    }

    function refreshActivity() {
      $scope.$broadcast("activity:refresh");
    }
  }
})();
